export const ALL_CDRS_BY_USER = `
query allCdrsByUser($userId: ID!) {
  allCdrsByUser(userId: $userId) {
    pk
    sk
    final
    cardId
    userId
    iccid
    msisdn
    cdrTimestamp
    service
    product
    originCountry
    originNumber
    destCountry
    destNetwork
    destNumber
    usedData
    volumeData
    volumeInBundle
    volumeOutBundle
    volumeTotalData
    volumeTotalMin
    volumeTotalMsg
    usedMoney
    usedData
    usedMin
    usedMsg
    cdrCurrency
    cdrTotal
    cdrInBundle
    cdrInvoiced
  }
}
`
